// extracted by mini-css-extract-plugin
export default {"card":"ArticleImage_card__IdU+x","label":"ArticleImage_label__pKp2D","name":"ArticleImage_name__UM3Qv","controls":"ArticleImage_controls__b98SR","link":"ArticleImage_link__jioyi"};